export default function PHP_MySQLConnect() {
  return (
    <div>
      <h1>PHP_MySQLConnect</h1>
    </div>
  );
}
